<script lang="ts" setup>
import { settings } from '@/constants/settings';

const {
  auth,
  commonMenuSrc,
  commonMenuDataRegistrationUrl,
  commonRealm,
  commonMenuDataBackendUrl,
} = settings;
</script>

<template>
  <div id="common_menu" />

  <component
    :is="'script'"
    id="common_menu_loader"
    defer
    type="text/javascript"
    charset="utf-8"
    data-ot-ignore=""
    :src="commonMenuSrc"
    data-service="mkreplays"
    data-project="mk"
    :data-realm="commonRealm"
    data-language="ru"
    :data-backend_url="commonMenuDataBackendUrl"
    data-token_url="/auth/menu-token/"
    data-login_url="/auth/login/"
    data-logout_url="/auth/logout/"
    :data-registration_url="commonMenuDataRegistrationUrl"
    data-incomplete_profile_url="https://lesta.ru/personal/"
    data-notifications_enabled="False"
    data-content_layout_max_width="1500"
    :data-user_id="auth && auth.spa_id"
    :data-user_name="auth && auth.username"
  />
</template>

<style lang="postcss">
:root {
  --common-menu-height: 37px;
}

#common_menu {
  height: var(--common-menu-height);
  background: rgb(33 33 33 / 85%);
  box-sizing: content-box;
  position: fixed;
  width: 100%;
  z-index: 10000;

  * {
    box-sizing: content-box;
  }
}
</style>
